export const getResult = (data) => {
  return data
}